/*=========================================================================================
  File Name: module-role-actions.js
  Description: Role Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	Roles: function(state) {
		return state.Roles;
	},
	Total: function(state) {
		return state.Total;
	},
	RolesLoaded: function(state) {
		return state.RolesLoaded;
	},
	AllRoles: function(state) {
		return state.AllRoles;
	},
	IsLoadingTotalRecords(state) {
		return state.IsLoadingTotalRecords;
	}
};
